"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.default = exports.CardFooter = void 0;
require("./CardFooter.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _ActionGroupDefault = _interopRequireDefault(require("../ActionGroupDefault/ActionGroupDefault"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * CardFooter component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns CardFooter
 */

const CardFooter = props => {
  const {
    /* Product action */
    actions,
    externalAction,
    /* Action settings */
    alignment = defaultProps.alignment,
    linkType,
    style,
    types,
    isKnockoutLink
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-CardFooter', {
    [`pal-c-CardFooter--${alignment}`]: alignment
  });

  /* If whole card is clickable display a textLink instead of ActionGroup */
  /* TODO: Update this when creating each card components */
  const isTextOnly = linkType === 'textLink';
  const textLink = isTextOnly ? 'textLink' : undefined;

  /* Show palette ActionGroup only when externalAction doesn't exist */
  const showPaletteActionGroup = actions && !externalAction;

  /* For Interrupters coupon variant pass tiny size secondary button
   we need it to be wrapped inside a span with aria attributes for ADA
   So needs to be passed as externalaction1 to ActionGroupDefault
   */
  const isCouponAction = actions?.filter(action => action?.coupon);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, externalAction && (0, _renderObject.renderObject)(externalAction), showPaletteActionGroup && /*#__PURE__*/_react.default.createElement(_ActionGroupDefault.default, {
    action1: actions[0],
    action2: actions[1],
    externalAction1: isCouponAction[0]?.externalAction1,
    style: style,
    type: types,
    isKnockoutLink: isKnockoutLink
  }), isTextOnly && /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "span",
    linkStyle: textLink,
    textAlign: alignment
  }, actions[0]?.label));
};

/**
 * Property type definitions
 * @type {object}
 * @property {object} action1 - action1 object
 * @property {object} action2 - action2 object
 * @property {string} align - Where the text content should align horizontally
 * @property {object} externalAction - external action object
 * @property {string} linkType - sets the link type based on if the card is fully clickable
 * @property {boolean} isKnockoutLink - sets the links to white when text is white
 */
exports.CardFooter = CardFooter;
CardFooter.propTypes = {
  /**
   * Sets the actions (palette only, no business logic)
   */
  actions: _propTypes.default.array,
  /**
   * Where the text content should align horizontally
   * - **left:** left side of available space
   * - **center:** center of available space
   * - **right:** right of available space
   * - **between:** space between actions
   * - **around:** equal space around actions
   */
  alignment: _propTypes.default.oneOf(['left', 'right', 'center', 'between', 'around']),
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Sets the link type based on if the card is fully clickable
   * - **hiddenLink:** sets the title text to be a hidden inline link
   * - **textLink:** sets the text to be link style for whole card clickable links
   * - **noLink:** sets the text have no link
   */
  linkType: _propTypes.default.oneOf(['hiddenLink', 'textLink', 'noLink']),
  /**
   * Sets the stylistic version of the actions
   * - **Primary Button/Secondary Button:** Sets the actions to display as the Primary Button and Secondary Button
   * - **Primary Button/Tertiary Button:** Sets the actions to display as the Primary Button and Tertiary Button
   * - **Primary Button/Primary Link:** Sets the actions to display as the Primary Button and Primary Link
   * - **Secondary Button/Primary Link:** Sets the actions to display as the Secondary Button and Primary Link
   *  - **Primary Link/Primary Link:** Sets the actions to display as two Primary Links
   * - **Arrow Link:** Sets the link to a arrow style
   */
  types: _propTypes.default.oneOf(['Primary Button/Secondary Button', 'Primary Button/Tertiary Button', 'Primary Button/Primary Link', 'Secondary Button/Primary Link', 'Primary Link/Primary Link', 'Arrow Link']),
  /**
   * Sets the layout of the actions
   * - **inline:** Sets the actions to display inline
   * - **stacked:** Sets the actions to display as block elements (flex column)
   * - **stackedFullWidth:** Sets the actions to display as block elements and also forces the buttons to the span full width of the parent container in all viewports. Links are centered but do not spand the full width.
   */
  style: _propTypes.default.oneOf(['inline', 'stacked', 'stackedFullWidth']),
  /**
   * sets the links to white when text is white
   */
  isKnockoutLink: _propTypes.default.bool
};

/**
 * Property type definitions
 * @type {object}
 * @property {string} align='left' - sets the default for align
 */
const defaultProps = exports.defaultProps = {
  alignment: 'left'
};
var _default = exports.default = CardFooter;